import { Controller } from "@hotwired/stimulus";

// Show/hide a grouped milestone section by toggling `d-none`, flip its caret, and
// reveal the group's collapsed-total cells. The <tbody> is a table sibling, located by id.
export default class extends Controller {
  static values = { bodyId: String };
  static targets = ["caretExpanded", "caretCollapsed"];

  toggle(event) {
    if (event.type === "keydown") {
      event.preventDefault();
    }

    const body = document.getElementById(this.bodyIdValue);
    if (!body) {
      return;
    }

    const collapsed = body.classList.toggle("d-none");

    if (this.hasCaretExpandedTarget && this.hasCaretCollapsedTarget) {
      this.caretExpandedTarget.classList.toggle("d-none", collapsed);
      this.caretCollapsedTarget.classList.toggle("d-none", !collapsed);
    }

    this.element.setAttribute("aria-expanded", String(!collapsed));

    const row = this.element.closest("tr");
    if (row) {
      row.querySelectorAll(".milestone-group-collapsed-total").forEach((cell) => {
        cell.classList.toggle("d-none", !collapsed);
      });
    }
  }
}
